export default __webpack_public_path__ + "static/media/ic_file_upload_success.a2bd3426.png";